import PropTypes from "prop-types";
import { createContext, useEffect } from "react";
// hooks
// utils
import getColorPresets, {
    colorPresets,
    defaultPreset,
} from "../utils/getColorPresets";
// config
import { defaultSettings } from "../config/theme.config";
import useLocalStorage from "./useLocalStorage";

// ----------------------------------------------------------------------

const initialState = {
    ...defaultSettings,
    onChangeMode: () => {},
    onToggleMode: () => {},
    onChangeColor: () => {},
    onResetSetting: () => {},
    setColor: defaultPreset,
    colorOption: [],
};

const SettingsContext = createContext(initialState);

// ----------------------------------------------------------------------

SettingsProvider.propTypes = {
    children: PropTypes.node,
};

function SettingsProvider({ children }) {
    const themeIsEnabled =
        import.meta.env.DEV &&
        import.meta.env.VITE_APP_THEME_SETTINGS === "true";
    const [settings, setSettings] = useLocalStorage("settings", {
        themeMode: initialState.themeMode,
        themeColorPresets: initialState.themeColorPresets,
    });
    const onChangeMode = (event) => {
        setSettings({
            ...settings,
            themeMode: event.target.value,
        });
    };

    const onToggleMode = () => {
        setSettings({
            ...settings,
            themeMode: settings.themeMode === "light" ? "dark" : "light",
        });
    };

    const onChangeColor = (event) => {
        setSettings({
            ...settings,
            themeColorPresets: event.target.value,
        });
    };

    const onResetSetting = () => {
        setSettings({
            themeMode: initialState.themeMode,
            themeLayout: initialState.themeLayout,
            themeColorPresets: initialState.themeColorPresets,
        });
    };

    useEffect(() => {
        if (!themeIsEnabled && settings.themeMode !== "light") {
            onResetSetting();
        }
    }, []);

    return (
        <SettingsContext.Provider
            value={{
                ...settings,
                // Mode
                onChangeMode,
                onToggleMode,
                // Direction

                // Color
                onChangeColor,
                setColor: getColorPresets(settings?.themeColorPresets),
                colorOption: colorPresets.map((color) => ({
                    name: color.name,
                    value: color.main,
                })),
                onResetSetting,
            }}
        >
            {children}
        </SettingsContext.Provider>
    );
}

export { SettingsProvider, SettingsContext };
